/**
 * Header: stays transparent over the hero, then fades to a solid dark bar once
 * the user scrolls past it so the nav stays legible over light sections.
 */
export function initHeader() {
  const header = document.getElementById('site-header')
  if (!header) return

  const syncHeader = () => {
    const scrolled = window.scrollY > window.innerHeight - 100
    header.classList.toggle('is-frosted', scrolled)
  }

  window.addEventListener('scroll', syncHeader, { passive: true })
  syncHeader()
}

/** Mobile menu toggle. */
export function initMobileMenu() {
  const toggle = document.getElementById('nav-toggle')
  const menu = document.getElementById('mobile-menu')
  if (!toggle || !menu) return

  // `is-open` drives the menu's CSS open/close transition; aria-expanded both
  // reports state and drives the hamburger→cross morph (see header.php).
  const setOpen = (open) => {
    menu.classList.toggle('is-open', open)
    toggle.setAttribute('aria-expanded', String(open))
  }
  toggle.addEventListener('click', () => setOpen(!menu.classList.contains('is-open')))
  // Close after tapping a link.
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)))
}
